export default __webpack_public_path__ + "static/media/Lip_8_M.449caf82.svg";